<eid-intro-one-desktop *ngIf="activeStep === 1" (step)="stepSelected($event)"></eid-intro-one-desktop>
<eid-intro-two-desktop *ngIf="activeStep === 2" (step)="stepSelected($event)"></eid-intro-two-desktop>
<eid-intro-three-desktop *ngIf="activeStep === 3" (step)="stepSelected($event)"></eid-intro-three-desktop>
<eid-intro-four-desktop *ngIf="activeStep === 4" (step)="stepSelected($event)"></eid-intro-four-desktop>
<eid-intro-five-desktop *ngIf="activeStep === 5" (step)="stepSelected($event)"></eid-intro-five-desktop>
